import React, { useState, useEffect, useRef } from "react";
import "./Style/common.css";
import "./Style/header.css";
import "./Style/MyStore.css";
import "./Style/trophy_club.css";
import Header from "../../Common/Header";
import Section from "../../Common/Section";
import Loading from "../../Common/Loading";
import CryptoJS from "crypto-js";

const SECRET_ENCRYPTION_KEY = "6GJZIa6J7NZzTdzf4K7Em6y6XiqwT09wqkKkNHaAvjE=";

function decrypt(encryptedBase64: string) {
  try {
    const key = CryptoJS.enc.Base64.parse(SECRET_ENCRYPTION_KEY);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return {};
  }
}

interface PurchaseStore {
  StoreID: string;
  StoreTitle: string;
  Price: string;
  StoreImageLink: string;
}
interface Store {

  StoreID: number;

  StoreTitle: string;

  Price: number;

  ItemType: string;

  Image: string;

  TermsAndCondition: string;

  ClosesOn: string;

  ClosesOnText: string;

  BuyBtnText: string;

  CssClassForBuyBtn: string;

  CssClassForNewOrEndingSoon: string;

  NewOrEndingSoonText: string;

  NoOfSecondsRemaining: number;

  TotalPurchasedStore: number;

  TotalAvailableStore: number;
}

const MyStore: React.FC = () => {

  const [purchaseStore] = useState<PurchaseStore[]>([]);
  const [myPoints, setMyPoints] = useState<number>(() => {
    const stored = sessionStorage.getItem("CurrentPoints");
    return stored ? parseInt(stored, 10) : 0;
  });
  const [stores, setStores] = useState<Store[]>([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [purchaseSuccessful, setPurchaseSuccessful] = useState(false);
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState<Store | null>(null);
  const [loadingUnits, setLoadingUnits] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showBackToBottom, setShowBackToBottom] = useState(true);
  const scrollContainerRef = useRef<HTMLElement | null>(null);
  // const apiUrl = process.env.REACT_APP_DOCUMENT_LINK || "http://127.0.0.1:8000/";
  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1100);

  const findScrollContainer = (): HTMLElement => {
    const candidates: (HTMLElement | null)[] = [
      (document.scrollingElement as HTMLElement) || null,
      document.getElementById("contents_math"),
      document.getElementById("main_top_container"),
      document.getElementById("contents_english"),
      document.getElementById("contents_physics"),
      document.getElementById("contents_chemistry"),
      document.getElementById("contents_biology"),
      document.body,
      document.documentElement,
    ];

    for (const el of candidates) {
      if (!el) continue;
      try {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        if (el.scrollHeight > el.clientHeight && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay" || overflowY === "visible")) {
          return el;
        }
      } catch (e) {
      }
    }
    return (document.scrollingElement as HTMLElement) || document.documentElement;
  };

  // detect and store the scroll container so click handlers can scroll the same element
  scrollContainerRef.current = findScrollContainer();
  const registeredContainer = scrollContainerRef.current;

  const handleScroll = () => {
    const el = (scrollContainerRef.current || registeredContainer || (document.scrollingElement as HTMLElement) || document.documentElement) as HTMLElement;
    const scrollTop = el.scrollTop;
    const innerH = el.clientHeight || window.innerHeight;
    const scrollHeight = el.scrollHeight;

    const scrollable = Math.max(0, scrollHeight - innerH);
    const TOL = 6;
    const atTop = scrollTop <= TOL;
    const atBottom = scrollTop >= Math.max(0, scrollable - TOL);
    const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

    if (atTop) {
      setShowBackToBottom(true);
      setShowBackToTop(false);
      return;
    }

    if (atBottom) {
      setShowBackToTop(true);
      setShowBackToBottom(false);
      return;
    }

    if (ratio < 0.5) {
      setShowBackToBottom(true);
      setShowBackToTop(false);
    } else {
      setShowBackToTop(true);
      setShowBackToBottom(false);
    }
  };
  try {
    if (registeredContainer) {
      registeredContainer.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }
  } catch (e) {
    window.addEventListener("scroll", handleScroll, { passive: true });
  }

  // run once to set initial state
  setTimeout(handleScroll, 0);
  useEffect(() => {
    const fetchStore = async () => {
      setLoadingUnits(true);

      try {
        const res = await fetch(`${apiUrl}MyStore/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Login: sessionStorage.getItem("Login"),
            FamilyCode: sessionStorage.getItem("FamilyCode"),
            SchoolCode: sessionStorage.getItem("SchoolCode"),
          }),
        });

        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);

        const payload = await res.json();

        if (payload && typeof payload.data === "string") {
          const decrypted = decrypt(payload.data);

          if (Array.isArray(decrypted)) {
            setStores(decrypted);
            setErrorMsg(null);
          } else {
            if (Array.isArray(payload)) {
              setStores(payload);
              setErrorMsg(null);
            } else {
              setStores([]);
              setErrorMsg("Invalid store data.");
            }
          }
        } else {
          if (Array.isArray(payload)) {
            setStores(payload);
            setErrorMsg(null);
          } else {
            setStores([]);
            setErrorMsg("Invalid store data.");
          }
        }
      } catch (err) {
        console.error("Error fetching store:", err);
        setErrorMsg("Failed to load store data.");
        setStores([]);
      } finally {
        setLoadingUnits(false);
      }
    };

    fetchStore();
  }, [apiUrl]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 1100);
    };

    window.addEventListener("resize", handleResize);

    // Set initial value
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePurchase = async (storeID: string) => {
    const schoolCode = sessionStorage.getItem("SchoolCode");
    const familyCode = sessionStorage.getItem("FamilyCode");
    const login = sessionStorage.getItem("Login");

    if (!schoolCode || !familyCode || !login) {
      alert("Missing user session info!");
      return;
    }

    try {
      setLoadingUnits(true);

      const res = await fetch(`${apiUrl}purchase_store_item/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          SchoolCode: schoolCode,
          FamilyCode: familyCode,
          Login: login,
          StoreID: storeID,
        }),
      });

      const payload = await res.json();

      if (!res.ok) {
        alert(payload.error || "Purchase failed");
        return;
      }

      let data;
      if (payload && typeof payload.data === "string") {
        data = decrypt(payload.data);
      } else {
        data = payload;
      }

      setMyPoints(data.NewPoints);
      sessionStorage.setItem("CurrentPoints", String(data.NewPoints));
      window.dispatchEvent(new Event("pointsUpdated"));

      setStores((prevStores) =>
        prevStores.map((store) =>
          store.StoreID === Number(storeID)
            ? {
              ...store,
              BuyBtnText: "Purchased",
              CssClassForBuyBtn: "btn-disabled",
              TotalPurchasedStore: 1,
            }
            : store
        )
      );
      setPurchaseSuccessful(true);
      window.location.reload();
    } catch (err) {
      console.error("Purchase failed:", err);
      setPurchaseSuccessful(false);
      alert("Failed to complete purchase");
    } finally {
      setLoadingUnits(false);
    }
  };

  return (
    <form>
      {showDetails && selectedDetail && (
        <div className="mi_store_details_lightbox" style={{ display: 'block' }}>
          <p>
            <span className="title_text wlp_add_activity_title_text" id="mi_store_details_lightbox_main_title">
              Store Item Terms and Conditions
            </span>
          </p>
          <br />
          <p>
            <span className="mi_store_details_lightbox_title">
              {selectedDetail.StoreTitle}
            </span>
          </p>
          <p>
            <span className="mi_store_details_lightbox_text" style={{ textAlign: 'center' }}>
              {selectedDetail.TermsAndCondition}
            </span>
          </p>
          <div className="button_box">
            <div
              className="general_btn two_btn_lightbox"
              onClick={() => setShowDetails(false)}
            >
              <p>OK</p>
            </div>
          </div>
        </div>
      )}

      {showConfirm && selectedStore && (
        <div className="mi_store_lightbox" style={{ display: 'block' }}>
          <p>
            <span className="title_text wlp_add_activity_title_text">
              {purchaseSuccessful ? "Purchase Successful" : "Confirm Item Purchase"}
            </span> <br />
          </p>
          <div
            className="confirm_store_item_img"
            style={{
              backgroundImage: `url(${selectedStore.Image})`,
            }}
          >
            <div className={`store_tick${purchaseSuccessful ? " store_tick_visible" : ""}`}></div>
          </div>
          <p>
            <span className="mi_store_lightbox_title">
              {selectedStore.StoreTitle}
            </span>
            <span className="confirm_purchase_store_price">
              <span className="confirm_purchase_store_price_blue">
                {purchaseSuccessful ? "Purchase Successful" : `${selectedStore.Price} Points`}
              </span>
            </span>
          </p>
          {purchaseSuccessful && (
            <p className="confirm_purchase_store_price_id_info">
              Congratulations. Your voucher will be emailed within 2 business days.
            </p>
          )}
          <div className="button_box">
            {!purchaseSuccessful ? (
              <>
                <div
                  className="general_btn two_btn_lightbox two_btn_left mi_store_lightbox_cancel_btn"
                  onClick={() => {
                    setShowConfirm(false);
                    setPurchaseSuccessful(false);
                  }}
                >
                  <div>Cancel</div>
                </div>
                <div
                  className={`general_btn two_btn_lightbox mi_store_lightbox_confirm_btn${loadingUnits ? " purchase_confirm_disabled" : ""}`}
                  onClick={() => {
                    if (selectedStore && !loadingUnits) {
                      handlePurchase(String(selectedStore.StoreID));
                    }
                  }}
                  style={{
                    pointerEvents: loadingUnits ? "none" : "auto",
                    opacity: loadingUnits ? 0.6 : 1,
                    cursor: loadingUnits ? "default" : "pointer",
                  }}
                >
                  <div>{loadingUnits ? "Processing..." : "Confirm"}</div>
                </div>
              </>
            ) : (
              <div
                className="general_btn two_btn_lightbox mi_store_lightbox_ok_btn"
                onClick={() => {
                  setShowConfirm(false);
                  setPurchaseSuccessful(false);
                  setSelectedStore(null);
                }}
              >
                <div>OK</div>
              </div>
            )}
          </div>
        </div>
      )}
      {purchaseStore.map((store) => (
        <div
          key={store.StoreID}
          id={`mi_store_lightbox${store.StoreID}`}
          className="mi_store_lightbox"
        >
          <p>
            <span
              id={`mi_store_confirm_main_title${store.StoreID}`}
              className="title_text wlp_add_activity_title_text"
            >
              Confirm Item Purchase
            </span>
          </p>
          <div
            id={`confirm_store_item_img${store.StoreID}`}
            className="confirm_store_item_img"
            style={{ backgroundImage: `url(${store.StoreImageLink})` }}
          >
            <div
              id={`store_item_tick${store.StoreID}`}
              className="store_tick"
            ></div>
          </div>
          <p>
            <span
              id={`mi_store_lightbox_title${store.StoreID}`}
              className="mi_store_lightbox_title"
            >
              {store.StoreTitle}
            </span>
            <span className="confirm_purchase_store_price">
              <span
                id={`confirm_purchase_store_price_id${store.StoreID}`}
                className="confirm_purchase_store_price_blue"
              >
                {store.Price}
              </span>
            </span>
          </p>
          <div className="button_box">
            <div
              id={`mi_store_lightbox_cancel_btn${store.StoreID}`}
              className="general_btn two_btn_lightbox two_btn_left mi_store_lightbox_cancel_btn"
            >
              <div id={`lca${store.StoreID}`}>Cancel</div>
            </div>
            <div
              className="general_btn two_btn_lightbox mi_store_lightbox_confirm_btn"
              onClick={() => {
                if (selectedStore) {
                  handlePurchase(String(selectedStore.StoreID));
                }
              }}
            >
              <div>Confirm</div>
            </div>
            <div
              id={`mi_store_lightbox_ok_btn${store.StoreID}`}
              className="general_btn two_btn_lightbox mi_store_lightbox_ok_btn"
            >
              <div id={`lco${store.StoreID}`}>OK</div>
            </div>
          </div>
        </div>
      ))}

      <div id="main_top_container">
        <Header />
        <a
          href="#bottom"
          className="back-to-bottom"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = (container as any).scrollHeight;
              (document.body as any).scrollTop = document.body.scrollHeight;
            }, 400);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }
          }}
          aria-label="Back to bottom"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToBottom ? 1 : 0,
            transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToBottom ? 'auto' : 'none',
            position: 'fixed',
            left: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',


            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Bottom
        </a>

        <a
          href="#top"
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = 0;
              (document.body as any).scrollTop = 0;
            }, 300);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }
          }}
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToTop ? 1 : 0,
            transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToTop ? 'auto' : 'none',
            position: 'fixed',
            right: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Top
        </a>
        <Section />
        <div id="mi_banner" className="subject_banner">
          <div id="mi_banner_text_img"></div>
        </div>

        <div id="mi_page_btn_container">
          <div id="mi_page_btn_store" className="mi_page_btn mi_page_btn_selected">
            <a id="hlinkStore" href="/STUDENT/MSR/MyStore">Store</a>
          </div>
          <div id="mi_page_btn_avatars" className="mi_page_btn">
            <a id="hlinkMyIncentives" href="/STUDENT/MSR/MyIncentives">Avatars</a>
          </div>
          <div id="mi_page_btn_comp" className="mi_page_btn">
            <a href="/STUDENT/MSR/MyCompsCurrent">Comps</a>
          </div>
          <div id="mi_page_btn_purchase" className="mi_page_btn mi_page_btn_last">
            <a id="hlinkPurchases" href="/STUDENT/MSR/AllPurchases">Purchases</a>
          </div>
        </div>

        <div
          id="mi_page_store"
          className="contents section_container mi_page_bg"
          style={{ display: showConfirm ? "none" : undefined }}
        >
          <div
            id="mi_avatars_container"
            className="section_div d-flex justify-content-center"
          >
            {loadingUnits ? (
              <Loading />
            ) : errorMsg ? (
              <div style={{ padding: 16, color: "crimson" }}>{errorMsg}</div>
            ) : stores && stores.length > 0 ? (
              <>
                {stores.map((store) => (
                  <div
                    className="mi_store_single_box mi_store_single_box_expand"
                    key={store.StoreTitle}
                    style={{ position: "relative" }}
                  >
                    {(() => {
                      const buttonState = (store.BuyBtnText || "").toUpperCase();
                      const isPurchased = buttonState === "PURCHASED";
                      const isSoldOut = buttonState === "SOLD OUT";
                      const canAfford = myPoints >= store.Price;
                      const canBuy = !isPurchased && !isSoldOut && canAfford;
                      const buttonText = isPurchased
                        ? store.BuyBtnText || "Purchased"
                        : isSoldOut
                          ? "SOLD OUT"
                          : canAfford
                            ? store.BuyBtnText || "BUY"
                            : "EARN MORE POINTS";

                      return (
                        <>
                          <img
                            className="mi_store_single_box_image "
                            src={store.Image}
                            alt={store.StoreTitle}
                            onError={(e) => {
                              (e.currentTarget as HTMLImageElement).src =
                                "https://www.elearnoncloud.com/Storage/assets/Avatar/reading.png";
                            }}
                          />

                        {(store.NewOrEndingSoonText || isSoldOut) && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          background: isSoldOut ? "#000" : "#e60000",
                          color: "#fff",
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 20,

                          width: isMobileView ? "150px" : "64px",
                          height: isMobileView ? "40px" : "100%",
                        }}
                      >
                        <span
                          style={{
                            transform: isMobileView
                              ? "none"
                              : "rotate(-90deg)",

                            fontSize: isMobileView
                              ? "18px"
                              : "16px",
                            letterSpacing: "2px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {isSoldOut ? "SOLD OUT" : store.NewOrEndingSoonText}
                        </span>
                      </div>
                    )}

                        <div className="mi_store_single_box_right_container">
                      <p className="mi_store_single_box_right_title">
                        {store.StoreTitle}
                      </p>
                      <p className="mi_store_single_box_right_price">
                        {store.Price} Points
                      </p>

                      <div className="mi_store_single_box_right_btn mi_store_single_box_right_buy_btn" style={{ display: isSoldOut ? "none" : "" }}>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            if (canBuy) {
                              setSelectedStore(store);
                              setPurchaseSuccessful(false);
                              setShowConfirm(true);
                            }
                          }}
                          style={{
                            pointerEvents: canBuy ? "auto" : "none",
                            opacity: canBuy ? 1 : 0.7,
                            cursor: canBuy ? "pointer" : "default",
                          }}
                        >
                          {buttonText}
                        </div>
                      </div>

                      <div className="mi_store_single_box_right_btn mi_store_single_box_right_details">
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            setSelectedDetail(store);
                            setShowDetails(true);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          DETAILS
                        </div>
                      </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                ))}
              </>
            ) : (
              <div style={{ padding: 16 }}>No stores available</div>
            )}
          </div>

          <div className="subject_middle_gap"></div>
          <div className="subject_middle_gap"></div>
        </div>
      </div>
    </form>
  );
};
export default MyStore;